import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const User = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill={fill}
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <g transform="translate(3 3)">
        <path d="M16.442 15.678A27.522 27.522 0 0 0 11.2 15.2a22.906 22.906 0 0 0-9.306 1.7A3.2 3.2 0 0 0 0 19.826V24a.8.8 0 0 0 .8.8h13.838a6.776 6.776 0 0 1 1.8-9.122z" />
        <path d="M11.2 13.6c3.663 0 6.4-3.8 6.4-7.2a6.4 6.4 0 1 0-12.8 0c0 3.4 2.737 7.2 6.4 7.2z" />
        <path d="M22.007 18.965L20.4 15.709l-1.607 3.256-3.593.522 2.6 2.534-.614 3.579 3.214-1.69 3.214 1.69L23 22.022l2.6-2.534z" />
      </g>
    </svg>
  );
};

User.displayName = 'User';
